/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_box_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What do the parts of a box mean?`)
};

const es_box_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué significan las partes de una caja?`)
};

const de_box_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was bedeuten die Teile einer Box?`)
};

const nl_box_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat betekenen de onderdelen van een box?`)
};

const fr_box_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que signifient les parties d'une boîte ?`)
};

const it_box_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cosa significano le parti di una scatola?`)
};

const pt_br2_box_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que significam as partes de uma caixa?`)
};

const pt_box_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que significam as partes de uma caixa?`)
};

const ja_box_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`箱の各部分は何を意味しますか？`)
};

const zh_box_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`箱体各部分代表什么？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const box_faq_q2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.box_faq_q2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("box_faq_q2", locale)
	if (locale === "en") return en_box_faq_q2(inputs)
	if (locale === "es") return es_box_faq_q2(inputs)
	if (locale === "de") return de_box_faq_q2(inputs)
	if (locale === "nl") return nl_box_faq_q2(inputs)
	if (locale === "fr") return fr_box_faq_q2(inputs)
	if (locale === "it") return it_box_faq_q2(inputs)
	if (locale === "pt-BR") return pt_br2_box_faq_q2(inputs)
	if (locale === "pt") return pt_box_faq_q2(inputs)
	if (locale === "ja") return ja_box_faq_q2(inputs)
	return zh_box_faq_q2(inputs)
};